import {defineMessages} from 'react-intl';

export default defineMessages({
	all: {
		id: 'plp.productsearchcategories.all',
		defaultMessage: 'All',
	},
});
